module.exports = __webpack_public_path__ + "img/walkin.7fcf5e78.svg";